<template>
    <div class="card" v-bind:class="imp">
        <div class="card-img">
            <img :src="image" alt=""></div>
        <div class="card-body">
            <h2>{{heading}}</h2>
            <p>{{txt}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name:"card",
    props:['image','heading', 'txt','imp']
  
}
</script>
<style scoped>
.card{
    display: flex;
     box-shadow: 3px 2px 3px 3px #e6e6e6;
 
    overflow: hidden;
    margin: 50px auto;
    padding: 2rem;
    border-radius: 1rem;
}p{
    color: hsl(208, 11%, 55%);
    font-size: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
}h2{
    margin-top: 10px;
    color: hsl(192, 100%, 9%);

}
.card-img{
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
@media(max-width: 720px){
    img{
        width: 16rem;
    }
    .card{
        flex-direction: column;
           width: 20rem;
    }p,h2{
        text-align: center;
    }
    h2{
        font-size: 20px;
    }
}
@media(min-width:721px){
    .card{
        width:75rem;
    }.card-rv{
        flex-direction: row-reverse;
    }
    .card-dr{
        flex-direction: row;
    }img{
        width: 20rem;
       margin: 0 3rem
    }.card-img{
        width: 35%
    }.card-body{
        width: 65%;
        align-content: center;
        padding: 3rem 5rem 3rem 5rem;
    }
}
</style>